<template>
  <div>
    <base-header type="gradient-rmn" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <users-table title="Users"></users-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UsersTable from "./Tables/UsersTable";
export default {
  name: "users",
  components: {
    UsersTable,
  },
};
</script>
<style></style>
